<template>
  <b-modal
    v-model="transferModal.status"
    title="Transfer Detayı"
    centered
    size="xl"
    no-close-on-esc
    no-close-on-backdrop
    hide-footer
  >
    <b-row v-if="transferModal.dataItem">
      <b-col
        cols="12"
        md="3"
      >
        <b-list-group>
          <donation-group />
          <bank-account />
          <safe-account />
          <donate-date />
          <is-receipt />
          <notes-text />
          <amount />
          <data-saved />
        </b-list-group>
      </b-col>
      <b-col>
        <transfer-form />
      </b-col>
    </b-row>
    <b-alert
      v-else
      show
    >
      <div class="alert-body text-center">
        <b-spinner />
        <div>Lütfen bekleyiniz...</div>
      </div>
    </b-alert>
  </b-modal>
</template>
<script>
import {
  BAlert, BListGroup, BModal, BSpinner, BRow, BCol,
} from 'bootstrap-vue'
import DonateDate from '@/views/Admin/Account_activities/Components/TransferModal/DonateDate.vue'
import DonationGroup from '@/views/Admin/Account_activities/Components/TransferModal/DonationGroup.vue'
import IsReceipt from '@/views/Admin/Account_activities/Components/TransferModal/IsReceipt.vue'
import DataSaved from '@/views/Admin/Account_activities/Components/TransferModal/DataSaved.vue'
import Amount from '@/views/Admin/Account_activities/Components/TransferModal/Amount.vue'
import NotesText from '@/views/Admin/Account_activities/Components/TransferModal/Notes.vue'
import SafeAccount from '@/views/Admin/Account_activities/Components/TransferModal/SafeAccount.vue'
import BankAccount from '@/views/Admin/Account_activities/Components/TransferModal/BankAccount.vue'
import TransferForm from '@/views/Admin/Account_activities/Components/TransferModal/TransferForm.vue'

export default {
  name: 'TransferModal',
  components: {
    BSpinner,
    BAlert,
    BListGroup,
    BModal,
    BRow,
    BCol,
    BankAccount,
    SafeAccount,
    NotesText,
    Amount,
    DataSaved,
    IsReceipt,
    DonationGroup,
    DonateDate,
    TransferForm,
  },
  computed: {
    transferModal() {
      return this.$store.getters['accountActivities/transferModal']
    },
  },
}
</script>
